/* 🤖 this file was generated by svg-to-ts */
export const mgcIconDownSmallCuteRe: {
  name: 'down-small-cute-re';
  data: string;
} = {
  name: 'down-small-cute-re',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.869 10.057c-.625.224-.872.901-.536 1.474.688 1.175 2.494 2.909 3.264 3.135.31.091.733.058 1.014-.08.462-.226 1.43-1.041 2.012-1.695.447-.502.952-1.174 1.085-1.445.401-.814-.388-1.688-1.235-1.368-.256.097-.347.188-.785.791a9.372 9.372 0 0 1-1.369 1.472l-.319.266-.319-.266a9.372 9.372 0 0 1-1.369-1.472c-.435-.599-.53-.695-.777-.787-.251-.094-.451-.101-.666-.025"/></svg>`
};
